import { Component, Output, EventEmitter, inject, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-header',
  templateUrl: './header.html',
  styleUrl: './header.scss'
})
export class Header implements OnDestroy {
  @Output() loginClicked = new EventEmitter<void>();
  @Output() signupClicked = new EventEmitter<void>();
  
  private router = inject(Router);
  private routerSubscription: Subscription;
  
  // Track which button is selected
  selectedButton: 'login' | 'signup' | null = null;

  constructor() {
    this.routerSubscription = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        // Check the current URL and set the selected button
        if (event.urlAfterRedirects.includes('/sign-in')) {
          this.selectedButton = 'login';
        } else if (
          // event.urlAfterRedirects.includes('/sign-up/profile') ||
          event.urlAfterRedirects.includes('/sign-up')
        ) {
          this.selectedButton = 'signup';
        } else {
          this.selectedButton = null;
        }
      });
  }

  ngOnDestroy(): void {
    this.routerSubscription.unsubscribe();
  }

  onLogin(): void {
    this.selectedButton = 'login';
    this.loginClicked.emit();
    this.router.navigate(['/sign-in']);
  }

  navigateToForm1(): void {
    this.selectedButton = 'signup';
    this.signupClicked.emit();
    // Navigate based on current URL
    const currentUrl = this.router.url;
    if (currentUrl.includes('/sign-in')) {
      this.router.navigate(['/sign-up']);
    } 
    // else {
    //   this.router.navigate(['/sign-up/profile']);
    // }
  }
}